import type { PlayerState } from '@crowdset/domain';

export interface PlayerEvents {
  onReady(): void;
  onState(state: PlayerState): void;
  onError(code: number): void;
  onAutoplayBlocked(): void;
}

/** The only surface the sync engine uses — implemented by YouTube and the demo FakePlayer. */
export interface PlayerAdapter {
  readonly kind: 'youtube' | 'fake';
  mount(el: HTMLElement, events: PlayerEvents): Promise<void>;
  /** Load a video at a position. autoplay=false cues it without starting. */
  load(videoId: string, startMs: number, autoplay: boolean, durationMs: number): void;
  play(): void;
  pause(): void;
  seek(ms: number): void;
  stop(): void;
  currentTimeMs(): number;
  state(): PlayerState;
  setVolume(v: number): void;
  setMuted(m: boolean): void;
  destroy(): void;
}

/** Actionable copy for IFrame API error codes (https://developers.google.com/youtube/iframe_api_reference). */
export function playerErrorMessage(code: number): string {
  switch (code) {
    case 2:
      return 'This video id is invalid. The DJ may need to replace the track.';
    case 5:
      return 'Your browser could not play this video in the HTML5 player. Try another browser or reload.';
    case 100:
      return 'This video was removed or made private. The room will move on at the end of the turn.';
    case 101:
    case 150:
      return 'The owner does not allow this video to play on other sites.';
    case 153:
      return 'YouTube did not receive this site’s identity (missing Referer). This is a site configuration issue, not a problem with the video.';
    default:
      return `The player reported an error (${code}).`;
  }
}
